import React from "react"
import { IEvent } from "../../models/Event"
import {SponsorCard} from "./componets/sponser-card/SponserCard";

export const Sponsors: React.FC<{event: IEvent}> = ({event}) => {
    return (
        <section className="section sponsers-main-container">
            <div className="container">
                <h2 className="section-title">נותני חסות ומציגים באקספו</h2>
                <div className="sponsers-container">
                    {event.sponsors.map(sponser =>
                        <SponsorCard key={sponser.description} sponsor={sponser}/>
                    )}
                </div>
            </div>
        </section>
    )
}
